module.exports = __webpack_public_path__ + "static/media/headerLogo.f0dba0e4.png";